import React, { useState } from 'react';
import { Paper, BottomNavigation, BottomNavigationAction } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import PersonIcon from '@mui/icons-material/Person';
import { ROUTE_PATH } from '../../constants/route-constants';
import { useLocation, useNavigate } from 'react-router-dom';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchFlag } from '../../store/auctions/action';
import { prepareGADataAndSendEvent } from '../../tracking';
const tabEvents = {
    0: 'exploreClick',
    1: 'myBidsClick',
    2: 'myOrdersClick',
    3: 'accountClick',
};
const navigationItems = [
    { label: 'Explore', route: ROUTE_PATH.EXPLORE, icon: <DirectionsCarFilledIcon /> },
    { label: 'My Bids', route: ROUTE_PATH.MY_CARS, icon: <ManageHistoryIcon /> },
    { label: 'My Orders', route: ROUTE_PATH.ORDERS, icon: <FavoriteIcon /> },
    { label: 'Account', route: ROUTE_PATH.ACCOUNT, icon: <PersonIcon /> },
];

const NAVIGATION_MAPPING = {
    [ROUTE_PATH.EXPLORE]: 0,
    [ROUTE_PATH.MY_CARS]: 1,
    [ROUTE_PATH.ORDERS]: 2,
    [ROUTE_PATH.ACCOUNT]: 3
};

const Footer = () => {
    const { user } = useSelector(state => state);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [value, setValue] = useState(NAVIGATION_MAPPING[location.pathname]);

    const handleNavigation = (path, newValue) => {
        prepareGADataAndSendEvent(tabEvents[newValue], user, null, 'Footer');
        setValue(newValue);
        dispatch(setSearchFlag(false));
        navigate(path);
    };
    return (
        <Paper
            sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1 }}
            elevation={3}
        >
            <BottomNavigation
                showLabels
                value={value}
            >
                {navigationItems.map(({ label, route, icon }, index) => (
                    <BottomNavigationAction key={index}
                        label={label}
                        classes={{ selected: 'text-primary', root: 'uppercase', label: 'mt-2' }}
                        icon={icon}
                        onClick={handleNavigation.bind(null, route, index)}
                    />
                ))}
            </BottomNavigation>
        </Paper>
    );
};

export default Footer;
